/** URL query parameter value for showing the new chat view */
export const CHAT_VIEW_PARAM = {
  NEW_CHAT: "newChat",
} as const;

export const CHAT_ROUTES = {
  thread: (id: string) => `/chats/${id}`,
  /** URL for navigating to the new chat view on mobile */
  newChat: `/chats?view=${CHAT_VIEW_PARAM.NEW_CHAT}`,
} as const;
